import { Spin } from 'antd';
import { Suspense, lazy } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import Layout from '../../../../components/Layout';
import Menu from '../../../../components/Layout/Menu';

const UserUpdateContent = lazy(() => import('../../../../components/Pages/Users/[userId]/Update'));

export default function UserUpdate(): JSX.Element | null {
  document.title = `${process.env.REACT_APP_TITLE}: User Update page`;

  return (
    <Layout LeftMenu={Menu} transparent>
      <Suspense fallback={<Spin spinning indicator={<LoadingOutlined spin />} />}>
        <UserUpdateContent />
      </Suspense>
    </Layout>
  );
}
